import { BaseService } from './base.service';

export class AccessTokenService extends BaseService {
    baseUrl = '/access-token';
}
